import useAuth from "containers/auth/useHooks";
import React, { useEffect, useState } from "react";
import { useStore } from "react-redux";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const DrawerAmbassadorRole: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const { getPrivacyPolicy } = useAuth();
  const [termConditionContent, setTermConditionContent] = useState<[]>([]);
  // const [privacyPolicyContent, setPrivacyPolicyContent] = useState<[]>([]);
  useEffect(() => {
    getPrivacyPolicy(
      { heading: "Welcome Email and Training Session Details" },
      setTermConditionContent
    );
  }, []);

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[465px] overflow-y-auto bg-white p-4 md:p-10 shadow-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>
        <h3 className="text-darkYellowText text-lg font-semibold">
          Ambassador Role
        </h3>

        <div>
          {termConditionContent?.map((item: any) => (
            <div key={item.id} className="space-y-4">
              <h2 className="text-2xl font-bold text-black mb-4">
                {item.heading}
              </h2>
              <div
                className="text-labelTextColor text-sm"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default DrawerAmbassadorRole;
